import { render } from "./ListInvoice.vue?vue&type=template&id=c8276708&scoped=true"
import script from "./ListInvoice.vue?vue&type=script&lang=js"
export * from "./ListInvoice.vue?vue&type=script&lang=js"

import "./ListInvoice.vue?vue&type=style&index=0&id=c8276708&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8276708"]])

export default __exports__